import React, { useContext,useState, useEffect, useRef } from "react";
import { AgGridReact } from 'ag-grid-react';
import "../../CSS/general.css";
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import Axios from "axios";
import { loginAuthProvider } from "../../LoginAuthProvider";
import AuthenticationContext from "../../Store/Authentication-Context";
import { API_ROUTE, Routes } from "../../Helpers/Constants";
import moment from "moment";
import Button  from 'react-bootstrap/Button';
import Label from "reactstrap/lib/Label";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LoaderGif from "../../images/365 loading.gif";

const CWInvoice = (props) => {
    const [rowData, setRowData] = useState();
    const { setAuthContext } = useContext(AuthenticationContext);
    const [tableRefresh, setTableRefresh] = useState(true);
    const [finished, setFinished] = useState(false);
    const open = true;
    const [disable, setDisable] = useState(true);
    const gridApi = useRef(null);
    const [selectedInvoices, setSelectedInvoices] = useState(new Set());
    const [monthFilter, setMonthFilter] = useState("T");
    const divStyle = {
        display: open ? "block" : "none",
        zIndex: "10002", width: "99%"

    };
    const showToast = (type, message) => {
        toast(message, {
            position: 'top-right',
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            closeButton: true,
        });
        /*
        if (type === "success") {
            toast.success(message, {
                position: 'top-right',
                autoClose: 10000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
            });
        }
        else if (type === "error") {

            toast.error('! ' + message, {
                position: 'top-right',
                hideProgressBar: false,
                autoClose: 10000,
                pauseOnHover: true,
                draggable: false,
                closeButton: true, // Include a close button
                style: {
                    color: 'red' // Set the color to red
                },
                autoClose: true

            });
        }*/
       

       // toast.dismiss(toastId);
    };

    function updateDDdate(responseMessage) {


        const updateRowData = (responseMessage, rowData) => {
            // Extract invoice numbers and DD Processed Dates from the response message
            const updates = responseMessage.split(/\r?\n/).reduce((acc, line) => {
                const match = line.match(/Successfully updated invoice:(I-\d+) with DD processed Date:(\d{2}[-/]\d{2}[-/]\d{4} \d{2}:\d{2}:\d{2})/);
                if (match) {
                    const [, invoiceNumber, ddProcessedDate] = match;
                    acc[invoiceNumber] = ddProcessedDate;
                }
                return acc;
            }, {});

            // Update rowData
            const updatedRowData = rowData.map(item => {
                if (updates[item.invoiceNumber]) {
                    return {
                        ...item,
                        customFields: item.customFields.map(field =>
                            field.caption === "DD Processed Date"
                                ? { ...field, value: updates[item.invoiceNumber] }
                                : field
                        )
                    };
                }
                return item;
            });

            return updatedRowData;
        };
        
        setRowData(updateRowData(responseMessage, rowData));
        setTimeout(() => {
            if (gridApi.current) {
                gridApi.current.sizeColumnsToFit();
            }
        }, 100);
    }
    async function fetchInvoices(filter,isMounted) {
        try {
            const token = await loginAuthProvider.getAccessToken();
            const tokenString = token.accessToken;
            const config = {
                headers: {
                    Authorisation: `Bearer ` + tokenString,
                    CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                },
            };
           
            const response = await Axios.get(API_ROUTE + Routes.GET_CONNECTWISE_INVOICE + "/" +filter, config);
      
            if (isMounted && response?.data) {

                setRowData(response.data);
                setTableRefresh(false);
               
            }
        } catch (error) {
            console.error('Error fetching invoices:', error);
        }
    }
    useEffect(() => {
        let isMounted = true;
        fetchInvoices(monthFilter,isMounted);

        return () => {
            isMounted = false;
        };

    }, [monthFilter]);

    const dateFormatter = (params) => {
        return params.value ? moment(params.value, 'DD/MM/YYYY').format("DD-MM-YYYY") : '';
    };
    const dateFormatterValue = (value) => {
        return value ? moment(value, 'DD/MM/YYYY').format("DD-MM-YYYY") : '';
    };
    const renderTooltip = (props) => (
        <Tooltip id={`tooltip-${props.id}`} {...props}>
            {props.text}
        </Tooltip>
    );
    const handleClose = () => {
        props.closeCWInvoiceModal();
        //setOpen(false);
       
    };
    const dateFormatterForUTC = (params) => {

        if (params.value === "0001-01-01T00:00:00") {
            return "";
        }
        if (params.value) {
            // Use moment.js to parse and format the date
            const formattedDate = moment(params.value, 'YYYY-MM-DDTHH:mm:ss.SSSSSSS').format("DD-MM-YYYY");
            return formattedDate;
        } else {
            return ""; // or return params.value depending on your requirement
        }
    };


    const processInvoice = async () => {

        const selectedInvoiceRows = rowData.filter(row => selectedInvoices.has(row.id));

        if (selectedInvoiceRows.length === 0) {
         
            return;
        }
        setTableRefresh(true);
        let payload = selectedInvoiceRows;

        const tokenString = await setAuthContext("", new Date());
        const config = {
            headers: {
                Authorisation: `Bearer ${tokenString}`,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };

        try {

            await Axios.post(API_ROUTE + Routes.CW_PROCESS_INVOICE_PAYMENT, payload, config)
                .then((response) => {
                 
                    //fetchInvoices();
                    if (response && response.data) {
                       
                        updateDDdate(response.data);
                        showToast("success", response.data);
                        setTableRefresh(false);
                        setFinished(true);
                       
                    }


                })
                .catch((error) => {
                    console.error("Error deleting invoice:", error);
                    if (error?.response?.status === 440) {
                        window.location.href = "/TimeoutErrorHandler";
                    }
                });

        } catch (error) {
            console.error("Error deleting invoice:", error);
        }

    };


    const columnDefs = [
        {
            headerName: '', width: 75,
            headerCheckboxSelection: false,
            headerComponentFramework: () => {
                const allSelected = rowData.length > 0 && rowData.every(row => selectedInvoices.has(row.id));

                const toggleSelectAll = (e) => {
                    const checked = e.target.checked;
                    setSelectedInvoices(() => {
                        const newSet = new Set();
                        if (checked) {
                            rowData.forEach(row => newSet.add(row.id));
                            setDisable(false);
                        } else {
                            setDisable(true);
                        }
                        return newSet;
                    });
                };

                return (
                    <div style={{ textAlign: 'center' }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <input
                            type="checkbox"
                            checked={allSelected}
                            onChange={toggleSelectAll}
                        />
                    </div>
                );
            },
            cellRenderer: (params) => {
                const isChecked = selectedInvoices.has(params.data.id)
                const checkInvoices = (e) => {
                   
                        setSelectedInvoices((prev) => {
                            const updatedSet = new Set(prev);
                            if (e.target.checked) {
                                updatedSet.add(params.data.id);
                            } else {
                                updatedSet.delete(params.data.id);
                            }
                            //console.log(updatedSet.size, updatedSet)
                            if (updatedSet.size === 0)
                                setDisable(true);
                            else
                                setDisable(false);
                            return updatedSet;
                        });
                       // console.log(gridApi.current);
                      /*  setTimeout(() => {
                            if (gridApi.current) {
                                gridApi.current.sizeColumnsToFit();
                            }
                        }, 100);*/
                    
                };

                const deleteInvoice = async () => {
                    if (!finished) {
                        const del = window.confirm("THIS WILL REMOVE THIS INVOICE, OK TO CONTINUE?");

                        if (del) {

                            setTableRefresh(true);
                            let payload = {
                                ...params.data
                            };
                            const tokenString = await setAuthContext("", new Date());
                            const config = {
                                headers: {
                                    Authorisation: `Bearer ${tokenString}`,
                                    CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                                },
                            };

                            try {

                                await Axios.put(API_ROUTE + Routes.CW_DELETE_INVOICE_PAYMENT, payload, config)
                                    .then((response) => {
                                        fetchInvoices(monthFilter,true);

                                        if (response && response.data) {

                                            showToast("success", response.data);
                                            setTimeout(() => {
                                                if (gridApi.current) {
                                                    gridApi.current.sizeColumnsToFit();
                                                }
                                            }, 100);
                                        }


                                    })
                                    .catch((error) => {
                                        console.error("Error deleting invoice:", error);
                                        if (error?.response?.status === 440) {
                                            window.location.href = "/TimeoutErrorHandler";
                                        }
                                    });

                            } catch (error) {
                                console.error("Error deleting invoice:", error);
                            }
                        }
                    }
                };
               
                return (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <button className="a-icon" onClick={deleteInvoice}>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="black" version="1.1" id="Capa_1" viewBox="0 0 28 28" style={{ height: '15px', width: '15px', verticalAlign: 'middle' }}>
                                <g>
                                    <path d="M23.898,4.101C21.254,1.456,17.738,0,14,0c-3.739,0-7.255,1.456-9.899,4.101C1.456,6.745,0,10.261,0,14   s1.456,7.255,4.101,9.898C6.746,26.544,10.261,28,14,28c3.738,0,7.255-1.456,9.898-4.102C26.544,21.255,28,17.739,28,14   S26.544,6.745,23.898,4.101z M3,14c0-2.938,1.144-5.701,3.222-7.778C8.3,4.145,11.063,3,14,3c2.432,0,4.734,0.794,6.639,2.241   L5.241,20.639C3.794,18.736,3,16.432,3,14z M21.777,21.779c-2.077,2.078-4.84,3.222-7.777,3.222c-2.432,0-4.735-0.794-6.638-2.241   L22.758,7.364c1.447,1.902,2.241,4.207,2.241,6.638C25,16.939,23.855,19.701,21.777,21.779z"></path>
                                </g>
                            </svg>
                    </button>
                        <input type="checkbox" checked={isChecked} onChange={checkInvoices} style={{ verticalAlign: 'middle' }} />
                    </div>
                );
            }
        },
        {
            headerName: 'InvoiceNumber', field: 'invoiceNumber', sortable: true, filter: true, width: 100, comparator: function (valueA, valueB) {
                // Handle null values
                if (valueA == null && valueB == null) {
                    return 0;
                }
                if (valueA == null) {
                    return -1;
                }
                if (valueB == null) {
                    return 1;
                }

                // Handle empty values
                if (valueA.trim() === '' && valueB.trim() === '') {
                    return 0;
                }
                if (valueA.trim() === '') {
                    return -1;
                }
                if (valueB.trim() === '') {
                    return 1;
                }

                // Compare non-null and non-empty values
                const normalizedA = valueA.toLowerCase();
                const normalizedB = valueB.toLowerCase();

                if (normalizedA < normalizedB) {
                    return -1;
                }
                if (normalizedA > normalizedB) {
                    return 1;
                }
                return 0;
            }
},


        {
            headerName: 'Company Name', field: 'company.name', sortable: true, filter: true, width: 200, comparator: function (valueA, valueB) {
                // Handle null values
                if (valueA == null && valueB == null) {
                    return 0;
                }
                if (valueA == null) {
                    return -1;
                }
                if (valueB == null) {
                    return 1;
                }

                // Handle empty values
                if (valueA.trim() === '' && valueB.trim() === '') {
                    return 0;
                }
                if (valueA.trim() === '') {
                    return -1;
                }
                if (valueB.trim() === '') {
                    return 1;
                }

                // Compare non-null and non-empty values
                const normalizedA = valueA.toLowerCase();
                const normalizedB = valueB.toLowerCase();

                if (normalizedA < normalizedB) {
                    return -1;
                }
                if (normalizedA > normalizedB) {
                    return 1;
                }
                return 0;
            }
        }, {
            headerName: 'Invloice Total', field: 'total', sortable: true, filter: true, width: 125, comparator: function (valueA, valueB) {
                // Handle null values
                if (valueA == null && valueB == null) {
                    return 0;
                }
                if (valueA == null) {
                    return -1;
                }
                if (valueB == null) {
                    return 1;
                }

                // Handle empty values
                if (valueA.trim() === '' && valueB.trim() === '') {
                    return 0;
                }
                if (valueA.trim() === '') {
                    return -1;
                }
                if (valueB.trim() === '') {
                    return 1;
                }

                // Compare non-null and non-empty values
                const normalizedA = valueA.toLowerCase();
                const normalizedB = valueB.toLowerCase();

                if (normalizedA < normalizedB) {
                    return -1;
                }
                if (normalizedA > normalizedB) {
                    return 1;
                }
                return 0;
            }
        },
        {
            headerName: 'Date', field: 'date', sortable: true, filter: true, width: 150, valueFormatter: dateFormatterForUTC, getQuickFilterText: params => {
                return dateFormatter(params);
            }, comparator: function (date1, date2) {
                // Custom comparator function for datetime sorting
                if (date1 === undefined || date1 === null) {
                    // Treat undefined or null as greater than any defined date
                    return 1;
                }
                if (date2 === undefined || date2 === null) {
                    // Treat undefined or null as greater than any defined date
                    return -1;
                }

                return moment(date1, 'YYYY-MM-DDTHH:mm:ss.SSSSSSSZ').diff(moment(date2, 'YYYY-MM-DDTHH:mm:ss.SSSSSSSZ'));
                //return moment(date1, 'DD/MM/YYYY').diff(moment(date2, 'DD/MM/YYYY'));
            }},
        {
            headerName: 'Status', field: 'status.name', sortable: true, filter: true, width: 200, comparator: function (valueA, valueB) {
                // Handle null values
                if (valueA == null && valueB == null) {
                    return 0;
                }
                if (valueA == null) {
                    return -1;
                }
                if (valueB == null) {
                    return 1;
                }

                // Handle empty values
                if (valueA.trim() === '' && valueB.trim() === '') {
                    return 0;
                }
                if (valueA.trim() === '') {
                    return -1;
                }
                if (valueB.trim() === '') {
                    return 1;
                }

                // Compare non-null and non-empty values
                const normalizedA = valueA.toLowerCase();
                const normalizedB = valueB.toLowerCase();

                if (normalizedA < normalizedB) {
                    return -1;
                }
                if (normalizedA > normalizedB) {
                    return 1;
                }
                return 0;
            }
        }, {
            headerName: 'Due Date', field: 'dueDate', sortable: true, filter: true, width: 150, valueFormatter:  dateFormatterForUTC, getQuickFilterText: params => {
                return dateFormatter(params);
            }, comparator: function (date1, date2) {
                // Custom comparator function for datetime sorting
                if (date1 === undefined || date1 === null) {
                    // Treat undefined or null as greater than any defined date
                    return 1;
                }
                if (date2 === undefined || date2 === null) {
                    // Treat undefined or null as greater than any defined date
                    return -1;
                }

                return moment(date1, 'YYYY-MM-DDTHH:mm:ss.SSSSSSSZ').diff(moment(date2, 'YYYY-MM-DDTHH:mm:ss.SSSSSSSZ'));
                //return moment(date1, 'DD/MM/YYYY').diff(moment(date2, 'DD/MM/YYYY'));
            }
        },
        {
            headerName: 'Invoice Type', field: 'agreement.type', sortable: true, filter: true, width: 100, comparator: function (valueA, valueB) {
                // Handle null values
                if (valueA == null && valueB == null) {
                    return 0;
                }
                if (valueA == null) {
                    return -1;
                }
                if (valueB == null) {
                    return 1;
                }

                // Handle empty values
                if (valueA.trim() === '' && valueB.trim() === '') {
                    return 0;
                }
                if (valueA.trim() === '') {
                    return -1;
                }
                if (valueB.trim() === '') {
                    return 1;
                }

                // Compare non-null and non-empty values
                const normalizedA = valueA.toLowerCase();
                const normalizedB = valueB.toLowerCase();

                if (normalizedA < normalizedB) {
                    return -1;
                }
                if (normalizedA > normalizedB) {
                    return 1;
                }
                return 0;
            }
        }, {
            headerName: 'Currency', field: 'currency.currencyCode', sortable: true, filter: true, width: 100, comparator: function (valueA, valueB) {
                // Handle null values
                if (valueA == null && valueB == null) {
                    return 0;
                }
                if (valueA == null) {
                    return -1;
                }
                if (valueB == null) {
                    return 1;
                }

                // Handle empty values
                if (valueA.trim() === '' && valueB.trim() === '') {
                    return 0;
                }
                if (valueA.trim() === '') {
                    return -1;
                }
                if (valueB.trim() === '') {
                    return 1;
                }

                // Compare non-null and non-empty values
                const normalizedA = valueA.toLowerCase();
                const normalizedB = valueB.toLowerCase();

                if (normalizedA < normalizedB) {
                    return -1;
                }
                if (normalizedA > normalizedB) {
                    return 1;
                }
                return 0;
            }
        },
        {
            headerName: 'Invoice Balance', field: 'balance', sortable: true, filter: true, width: 100, resizable: true, comparator: function (valueA, valueB) {
                // Handle null and empty values
                if (valueA == null && valueB == null) {
                    return 0;
                }
                if (valueA == null) {
                    return -1;
                }
                if (valueB == null) {
                    return 1;
                }

                // Convert string values to numbers
                const numberA = parseFloat(valueA);
                const numberB = parseFloat(valueB);

                // Handle NaN (non-numeric) values
                if (isNaN(numberA) && isNaN(numberB)) {
                    return 0;
                }
                if (isNaN(numberA)) {
                    return -1;
                }
                if (isNaN(numberB)) {
                    return 1;
                }

                // Compare numeric values
                if (numberA < numberB) {
                    return -1;
                }
                if (numberA > numberB) {
                    return 1;
                }
                return 0;
            }
},
        {
            headerName: 'Sales Tax', field: 'salesTax', sortable: true, filter: true, width: 100, resizable: true, comparator: function (valueA, valueB) {
                // Handle null and empty values
                if (valueA == null && valueB == null) {
                    return 0;
                }
                if (valueA == null) {
                    return -1;
                }
                if (valueB == null) {
                    return 1;
                }

                // Convert string values to numbers
                const numberA = parseFloat(valueA);
                const numberB = parseFloat(valueB);

                // Handle NaN (non-numeric) values
                if (isNaN(numberA) && isNaN(numberB)) {
                    return 0;
                }
                if (isNaN(numberA)) {
                    return -1;
                }
                if (isNaN(numberB)) {
                    return 1;
                }

                // Compare numeric values
                if (numberA < numberB) {
                    return -1;
                }
                if (numberA > numberB) {
                    return 1;
                }
                return 0;
            }
        },
        {
            headerName: 'Billing Terms', field: 'billingTerms.name', sortable: true, filter: true, width: 100, resizable: true, comparator: function (valueA, valueB) {
                // Handle null and empty values
                if (valueA == null && valueB == null) {
                    return 0;
                    ////if (valueA == null) {
                    ////    return -1;
                    ////}
                    ////if (valueB == null) {
                    ////    return 1;
                    ////}

                    ////// Convert string values to numbers
                    ////const numberA = parseFloat(valueA);
                    ////const numberB = parseFloat(valueB);

                    ////// Handle NaN (non-numeric) values
                    ////if (isNaN(numberA) && isNaN(numberB)) {
                    ////    return 0;
                    ////}
                    ////if (isNaN(numberA)) {
                    ////    return -1;
                    ////}
                    ////if (isNaN(numberB)) {
                    ////    return 1;
                    ////}

                    ////// Compare numeric values
                    ////if (numberA < numberB) {
                    ////    return -1;
                    ////}
                    ////if (numberA > numberB) {
                    ////    return 1;
                    ////}
                    ////return 0;
                }
            }
        }, {
            headerName: 'DD Processed Date', sortable: true, filter: true, width: 100, valueGetter: (params) => {
                const ddProcessedField = params.data.customFields?.find(
                    (field) => field.caption === "DD Processed Date"
                ); 
                return ddProcessedField.value ; // Adjust as needed
            }
            , resizable: true, valueFormatter: dateFormatter, getQuickFilterText: params => {
               
                return dateFormatter(params);
            }, comparator: function (date1, date2) {
                // Custom comparator function for datetime sorting
                if (date1 === undefined || date1 === null) {
                    // Treat undefined or null as greater than any defined date
                    return 1;
                }
                if (date2 === undefined || date2 === null) {
                    // Treat undefined or null as greater than any defined date
                    return -1;
                }

                return moment(date1, 'YYYY-MM-DDTHH:mm:ss.SSSSSSSZ').diff(moment(date2, 'YYYY-MM-DDTHH:mm:ss.SSSSSSSZ'));
                //return moment(date1, 'DD/MM/YYYY').diff(moment(date2, 'DD/MM/YYYY'));
            }
        },
        {
            headerName: '', width: 20,
            cellRenderer: (params) => {
                const handleClick = () => {
                    window.open(params.data.xeroInvUrl, '_blank', 'height=800,width=1280,status=yes,toolbar=yes,menubar=yes,location=no');
                };
                return (
                   
                    <div className="justify-content-between d-flex align-items-center">
                        {params.data.invoiceNumber && params.data.invoiceNumber.includes("INV") &&
                            <button className="a-icon" onClick={handleClick}>
                                <OverlayTrigger key="sort-1" placement="top" delay={{ show: 50, hide: 50 }} overlay={(props) => renderTooltip({
                                    ...props, id: "sort-1", text: "Click to View Invoice\nPayment Details \n Inv Period: " + params.data.invoicePeriod + "\n Payment Date: "
                                        + dateFormatterValue(params.data.paymentDate) + "\n DD Ref: " + params.data.goPayID
                                        + "\n Note: " + params.data.note
                                })}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-receipt" viewBox="0 0 16 16">  <path d="M1.92.506a.5.5 0 0 1 .434.14L3 1.293l.646-.647a.5.5 0 0 1 .708 0L5 1.293l.646-.647a.5.5 0 0 1 .708 0L7 1.293l.646-.647a.5.5 0 0 1 .708 0L9 1.293l.646-.647a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .801.13l.5 1A.5.5 0 0 1 15 2v12a.5.5 0 0 1-.053.224l-.5 1a.5.5 0 0 1-.8.13L13 14.707l-.646.647a.5.5 0 0 1-.708 0L11 14.707l-.646.647a.5.5 0 0 1-.708 0L9 14.707l-.646.647a.5.5 0 0 1-.708 0L7 14.707l-.646.647a.5.5 0 0 1-.708 0L5 14.707l-.646.647a.5.5 0 0 1-.708 0L3 14.707l-.646.647a.5.5 0 0 1-.801-.13l-.5-1A.5.5 0 0 1 1 14V2a.5.5 0 0 1 .053-.224l.5-1a.5.5 0 0 1 .367-.27m.217 1.338L2 2.118v11.764l.137.274.51-.51a.5.5 0 0 1 .707 0l.646.647.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.509.509.137-.274V2.118l-.137-.274-.51.51a.5.5 0 0 1-.707 0L12 1.707l-.646.647a.5.5 0 0 1-.708 0L10 1.707l-.646.647a.5.5 0 0 1-.708 0L8 1.707l-.646.647a.5.5 0 0 1-.708 0L6 1.707l-.646.647a.5.5 0 0 1-.708 0L4 1.707l-.646.647a.5.5 0 0 1-.708 0z" />  <path d="M3 4.5a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5m8-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5" /></svg>
                                </OverlayTrigger>
                            </button>
                        }
                    </div>
                );
            },
        },
    ];
    
    return (
        <div
            style={divStyle}
            className="modal fade show"
            id="exampleModal"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"

        >
            <div style={{ width: "99%", display: 'flex', justifyContent: 'center' }} >
                <div className="modal-content" style={{ width: "99%" }} >
                    <div className="modal-header">
                        <h5>CW Direct Debit</h5>
                       
                        <button type="button" className="btn-close" aria-label="Close" onClick={handleClose}></button>
                    </div>
                    <div className="modal-body">
                        <div style={{ width: "99%", display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                            <div style={{ display: 'flex', gap: '2px',fontSize:'16px' }}>
                              
                <Label className="mb-2">Invoice Due Date:</Label>
                <select
                 value={monthFilter === "" ? "T" : monthFilter}
                                    onChange={(e) => { setMonthFilter(e.target.value); setTableRefresh(true); }}
                    style={{ padding: "5px", borderRadius: "4px", border: "1px solid #ccc", cursor: "pointer" }}
                >
                    <option value="T">This Month</option>
                    <option value="N">Next Month</option>
                    <option value="L">Last Month</option>
                                </select>
                                </div>
                            <div style={{ display: 'flex', gap: '2px' }}>
                                <button id="ContentPlaceHolder1_btnRefresh" className="me-1 a-icon" style={{ color: "#007bff", top: '2.5rem', float: 'inline-end' }}><Button title="Refresh" onClick={(e) => {

                                   setRowData(null);
                                   setTableRefresh(true);
                                   setFinished(false);
                                   setDisable(true);
                                    setSelectedInvoices(new Set());
                                        fetchInvoices(monthFilter, true);
                                   
                                }
                                } variant="primary"> <i className="fas fa-sync"></i> </Button></button>
                                <button id="ContentPlaceHolder1_btnClear" style={{ color: "#007bff", cursor: 'pointer', float: 'inline-end', justifyContent: 'flex-end' }} className="me-1 a-icon">
                                    <Button title="Clear Filter" onClick={(e) => {
                        if (gridApi.current) {
                            gridApi.current.setFilterModel(null);
                        }
                    }
                    } variant="primary" style={{ padding: '5px 6px' }} >
                        <svg xmlns="http://www.w3.org/2000/svg" height="20" fill="white" stroke="white" viewBox="0 0 32 32" width="20" style={{ cursor: 'pointer' }}>
                            <path strokeWidth="1.5" d="m30 11.414-1.414-1.414-4.586 4.586-4.586-4.586-1.414 1.414 4.586 4.586-4.586 4.585 1.415 1.415 4.585-4.586 4.587 4.586 1.413-1.413-4.586-4.587z"></path>
                            <path strokeWidth="1.5" d="m4 4a2 2 0 0 0 -2 2v3.1709a2 2 0 0 0 .5859 1.4145l7.4141 7.4146v8a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-2h-2v2h-4v-8.8291l-.5859-.5855-7.4141-7.4145v-3.1709h20v2h2v-2a2 2 0 0 0 -2-2z"></path>
                        </svg>
                    </Button>
                </button>
                                <button id="ContentPlaceHolder1_btnDownload" style={{ color: "#007bff", cursor: 'pointer', top: '2.5rem', float: 'inline-end', justifyContent: 'flex-end' }} className="me-2 a-icon">
                                    <Button title="Download" onClick={(e) => {
                        if (gridApi.current) {
                            gridApi.current.exportDataAsCsv();
                            // gridApiRefs.operations.current.sizeColumnsToFit();
                        }

                    }
                    } variant="primary">   <svg
                                            className="svg-inline--fa fa-download fa-w-18 fa-lg"
                                            style={{ color: 'white', fill: 'transparent', fontSize: '16px' }}
                                            aria-hidden="true"
                                            focusable="false"
                                            data-prefix="far"
                                            data-icon="download"
                                            role="img"
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 576 512"
                                        >
                                            <path
                                                fill="currentColor"
                                                d="M528 288h-92.1l46.1-46.1c30.1-30.1 8.8-81.9-33.9-81.9h-64V48c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48v112h-64c-42.6 0-64.2 51.7-33.9 81.9l46.1 46.1H48c-26.5 0-48 21.5-48 48v128c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V336c0-26.5-21.5-48-48-48zm-400-80h112V48h96v160h112L288 368 128 208zm400 256H48V336h140.1l65.9 65.9c18.8 18.8 49.1 18.7 67.9 0l65.9-65.9H528v128zm-88-64c0-13.3 10.7-24 24-24s24 10.7 24 24-10.7 24-24 24-24-10.7-24-24z"
                                            />
                                        </svg></Button>

                    </button>
              </div>
            </div>
            <div className="ag-theme-alpine ms-2"
                style={{ borderColor: "#F0F0F0", borderStyle: "Solid", width: "99%", height: '70vh', maxHeight: '70vh' }}>
                {tableRefresh ?
                    <div className="justify-content-center align-items-center d-flex h-100" style={{ minHeight: '35vh' }}>
                        <img src={LoaderGif} alt="loading" style={{ height: '70px' }} />
                    </div> :
                    <AgGridReact 
                        rowData={rowData}
                        columnDefs={columnDefs}
                        //  defaultColDef={defaultColDef}
                        animateRows={true}
                        enableCellTextSelection="true"
                        overlayLoadingTemplate={
                            `<div style="position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);"><div><div style="text-align: center;"><img src="${LoaderGif}" alt="loading" style="height: 50px;"></div><span>Please wait while your rows are loading...</span></div></div>`}
                        overlayNoRowsTemplate={'<span className="ag-overlay-loading-center">No records to show</span>'}

                        onGridReady={(params) => {

                            gridApi.current = params.api;
                            params.api.sizeColumnsToFit();
                           
                            
                        }}
                        onFirstDataRendered={(params) => {
                            params.api.sizeColumnsToFit();
                        }}
                        onSelectionChanged={() => {
                            if (gridApi.current) {
                                gridApi.current.sizeColumnsToFit();
                            }

                        }}
                        onGridSizeChanged={(params) => {
                            params.api.sizeColumnsToFit();
                        }}
                        onModelUpdated={(params) => {
                            params.api.sizeColumnsToFit(); // Re-adjust column sizes
                        }}
                    ></AgGridReact>
                }
            </div>
            <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", marginTop: "10px" }}>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>&nbsp;
                <Button disabled={tableRefresh || finished || disable } variant="primary" onClick={processInvoice}>
                    Submit
                </Button>&nbsp;&nbsp;
                        </div>
                    </div>
                </div>
                    </div>
            <ToastContainer limit={4} style={{ fontSize: "small" }} /></div>
      
    );
}

export default CWInvoice;
